import { getCompatibleAuthTokenHttp } from 'src/services/utils/enhancedAuthTokenHttp';
import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { MutationFunction } from '@tanstack/react-query';

export interface DocumentGroupingConfiguration {
  required: boolean;
  validityRule: string;
  filesPerBorrower: number;
  documentTypeId: string;
}

export interface UpdateDocumentGroupingParams {
  id: string;
  name?: string;
  configuration?: DocumentGroupingConfiguration[];
  isDeleted?: boolean;
}

export interface UpdateDocumentGroupingResponse {
  success: boolean;
  grouping: {
    id: string;
    name: string;
    configuration: DocumentGroupingConfiguration[];
    userId: string;
    createdAt: string;
    updatedAt: string;
    isDeleted: boolean;
  };
  message: string;
}

const updateDocumentGrouping: MutationFunction<
  UpdateDocumentGroupingResponse,
  UpdateDocumentGroupingParams
> = async (args) => {
  if (isMockServices()) return await mock(_mockData);

  const { id, ...updateData } = args;
  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<UpdateDocumentGroupingResponse>(
    `/document-groupings/${id}`,
    {
      method: 'PUT',
      body: updateData,
    },
  );
  if (response.data) return response.data;
  throw new Error('Failed to update document grouping');
};

export default updateDocumentGrouping;

const _mockData: UpdateDocumentGroupingResponse = {
  success: true,
  grouping: {
    id: 'mock-1',
    name: 'Updated Document Stack',
    configuration: [
      {
        required: true,
        validityRule: 'valid',
        filesPerBorrower: 1,
        documentTypeId: 'doc-type-1',
      },
    ],
    userId: 'user-123',
    createdAt: '2025-01-01T00:00:00Z',
    updatedAt: '2025-01-02T00:00:00Z',
    isDeleted: false,
  },
  message: 'Document grouping updated successfully.',
};
